import FacturaCreditoRepository from '@/services/FacturaCreditoRepository'

export default {
  namespaced: true,
  state: {
    entidad: null,
    listaFacturasCredito: [],
  },
  mutations: {
    setDetalle(state, facturasCredito) {
      let monedas = [...new Set(facturasCredito.map(factura => factura.moneda))]
      let facturasMoneda = monedas.map(moneda => {
        let facturasPorMoneda = facturasCredito.filter(factura => factura.moneda === moneda)

        let listaDepartamentos = [...new Set(facturasPorMoneda.map(factura => factura.nombreDepartamento))]
        let listaDepartamentosTotales = listaDepartamentos.map(factura=>{
          let departamentosFiltrado = facturasPorMoneda.filter(facturaCredito => facturaCredito.nombreDepartamento === factura)
          let saldoTotalDepartamento = departamentosFiltrado.reduce((suma,factura) => suma + factura.saldoCuota, 0)
          return{
            nombreDepartamento:factura,
            saldoTotal:saldoTotalDepartamento,
          }
        })
        let saldoTotalMoneda = listaDepartamentosTotales.reduce((suma,departamento) => suma + departamento.saldoTotal,0)

        let facturasUnicas = [...new Set(facturasPorMoneda.map(factura => factura.idDocumentoVenta))]
        let cuotasAgrupadas = facturasUnicas.map(documentoVenta => {
          let facturasCuotas = facturasPorMoneda.filter(factura => factura.idDocumentoVenta === documentoVenta)
          let expandir = facturasCuotas.length > 1 ? true : false
          let idDocumentoVenta = facturasCuotas[0].idDocumentoVenta
          facturasCuotas.map(cuota => cuota.idDocumentoVenta = cuota.numeroCuota)
          return {
            facturas: facturasCuotas,
            idDocumentoVenta, 
            nombreDepartamento: facturasCuotas[0].nombreDepartamento,
            diasCuota: facturasCuotas[0].diasCuota,
            fechaEmision: facturasCuotas[0].fechaEmision,
            fechaVencimientoCuota: facturasCuotas[0].fechaVencimientoCuota,
            importeFactura: facturasCuotas[0].importeFactura,
            numeroDocumento: facturasCuotas[0].numeroDocumento,
            saldoFactura: facturasCuotas[0].saldoFactura,
            expandir,
            decimalesMoneda: facturasCuotas[0].decimalesMoneda
          }
        })
        return{
          moneda,
          decimalesMoneda: cuotasAgrupadas[0].decimalesMoneda,
          listaFacturasCredito: cuotasAgrupadas,
          listaDepartamentosTotales,
          saldoTotalMoneda,
        }
      })
      state.listaFacturasCredito = facturasMoneda
    },
  },
  actions: {
    async fetchDetalle({ commit}) {
      let facturasCredito = await FacturaCreditoRepository.detalle()
      commit('setDetalle', facturasCredito)
    },
  }
}
